import {MutationTree} from "vuex"
import {WidgetState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {Config, ISteps, Labels} from "../models/config-viewmodel"

export default <MutationTree<WidgetState>>{
    setConfig(state, config: Config) {
        state.config = config
    },
    setLabels(state, labels: Labels) {
        state.config.labels = labels
    },
    setMyStudyChoice(state, myStudyChoice: string) {
        state.myStudyChoice = myStudyChoice
    },
    setActiveStepIndex(state, activeStepIndex: number) {
        state.activeStepIndex = activeStepIndex
    },
    setActiveSubStepIndex(state, activeSubStepIndex: number) {
        state.activeSubStepIndex = activeSubStepIndex
    },
    setSteps(state, steps: ISteps) {
        state.steps = steps
    },
    setReverse(state, reverse: boolean) {
        state.reverse = reverse
    },
    setCanContinue(state, canContinue: boolean) {
        state.canContinue = canContinue
    },
    setOnboardingIsActive(state, onboardingIsActive: boolean) {
        state.onboardingIsActive = onboardingIsActive
    },
    setOnboardingIsCompleted(state, onboardingIsCompleted: boolean) {
        state.onboardingIsCompleted = onboardingIsCompleted
    }
}
